export const GET_EMPLOYEE_REQUEST = "@employee/GET_EMPLOYEE_REQUEST";
export const GET_EMPLOYEE_SUCCESS = "@employee/GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_FAILURE = "@employee/GET_EMPLOYEE_FAILURE";